import { ErrorTypes } from './generated/api.enum';

/**
 * Default error on failed fetch requests
 */
export class FetchError extends Error {
  requestInfo: unknown;
  responseInfo: unknown;

  constructor(message?: string, requestInfo: unknown = {}, responseInfo: unknown = {}) {
    const translationKey = message ?? ErrorTypes.UNKNOWN;

    super(translationKey);
    Object.setPrototypeOf(this, FetchError.prototype);

    this.requestInfo = requestInfo;
    this.responseInfo = responseInfo;
  }
}
